import { render, staticRenderFns } from "./VrstaTemeDetails.vue?vue&type=template&id=b62cf702&scoped=true&"
import script from "./VrstaTemeDetails.vue?vue&type=script&lang=js&"
export * from "./VrstaTemeDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b62cf702",
  null
  
)

export default component.exports